import React, {  useEffect, useState, useMemo, useRef } from "react";
import { useLocation } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import Footer from './shared/Footer';
import admindata from './components/admindata';
import axios from "axios";
import { apiRequest } from './store/allApi';
import { ChatCallProvider, usePackageAuth, ChatWidget, E2eeProvider, usePushNotifications, useOriginSettings,
  openTeloChat, } from 'react-chat-call-socket';
import { chatConfig } from './chatConfig.js';

const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
const nodeMode = process.env.NODE_ENV;
const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;


function NotificationSetup({ user }) {
  const { permission, supported, subscribed, enable } = usePushNotifications({
    username: user?.name || 'Guest',
    vapidPublicKey: chatConfig.vapidPublicKey,
    appPath: '/',
  });

  useEffect(() => {
    if (permission === 'granted' && !subscribed) {
      enable().catch(() => {});
    }
  }, [permission, subscribed, enable]);

  if (!chatConfig.vapidPublicKey || !supported) return null;

    {permission !== 'granted' ?  console.log("Enable push notifications") : subscribed ? console.log('Push notifications enabled.') : console.log('Notifications permission granted.')};
  // return (
  //   <div style={{ marginBottom: 12 }}>
  //     {permission !== 'granted' ? (
  //       <button type="button" onClick={enable}>
  //         Enable push notifications
  //       </button>
  //     ) : (
  //       <span>{subscribed ? 'Push notifications enabled.' : 'Notifications permission granted.'}</span>
  //     )}
  //   </div>
  // );
}

const App = ({ children, loggedInUser, loading }) => {

  // BASE URL
   const access_token = localStorage.getItem("token");
    const profile = React.useMemo(
      () => ({
        name: loggedInUser?.name,
        mobile: loggedInUser?.mobile,
        profile_pic: loggedInUser?.avatarUrl,
      }),
      [loggedInUser]
    );
  
    const { user, token, error } =  usePackageAuth({
      apiUrl: chatConfig.apiUrl,
      apiKey: chatConfig.apiKey,
      appToken: access_token,
      userType: chatConfig.userType,
      profile,
    });
  
    const embedOrigin =
        typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}` : '';
    
      const { settings: originSettings } = useOriginSettings({
        apiUrl: chatConfig.apiUrl,
        apiKey: chatConfig.apiKey,
        origin: user?.origin || embedOrigin,
      });
    
      if (loading ) console.log('Connecting chat…');
      if (error) {
       console.log('Chat auth failed: {error.message || String(error)}')
      }
    
      const hideChatButton = Boolean(originSettings?.hideChatButton);
      const hideCallButton = Boolean(originSettings?.hideCallButton);
      const showLauncher = chatConfig.showLauncher !== false && !hideChatButton;

  const location = useLocation();
  const [state, setState] = useState({});
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  const mee = async() => {
    const token = localStorage.getItem("token");
    
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
      try {
          const res = await apiRequest(`admin/me`,"GET", null,headers)
         if (res.data) {
          let permission;
            localStorage.setItem("id", res.data?.id);
            if (token) {
              if (res.data.user_type === "Admin") {
                permission = { usertype: 'Admin', userAname: res.data.Name, dashboard: true, earnings: true, allAdmins: true, newAdmin: true, allUsers: true, sitesettings: true, newUser: true, pendingKyc: true, completedKyc: true, rejectKyc: true, supportChat: true, pushNotification: true, updateLegalData: true, allChallenges: true, completedChallenges: true, conflictChallenges: true, cancelledChallenges: true, runningChallenges: true, newChallenge: true, penaltyBonus: true, bonus: true, depositHistory: true, bonusHistory: true, withdrawlHistory: true, allWithdrawlRequests: true, allDepositRequests: true, pages: true, bonusReport: true, penaltyReport: true, withdrawalReport: true, depositReport: true, GetwaySetting: true };
              } else if (res.data.user_type === "Agent") {
                permission = { usertype: 'Agent', userAname: res.data.Name ,
                  
              dashboard: res.data.Permissions[0]?.Status,
              earning: res.data.Permissions[1]?.Status,
              allAdmins: res.data.Permissions[2]?.Status,
              newAdmin: res.data.Permissions[3]?.Status,
              allUsers: res.data.Permissions[4]?.Status,
              newUser: res.data.Permissions[5]?.Status,
              pendingKyc: res.data.Permissions[6]?.Status,
              completedKyc: res.data.Permissions[7]?.Status,
              rejectKyc: res.data.Permissions[8]?.Status,
              allChallenges: res.data.Permissions[9]?.Status,
              completedChallenges: res.data.Permissions[10]?.Status,
              conflictChallenges: res.data.Permissions[11]?.Status,
              cancelledChallenges: res.data.Permissions[12]?.Status,
              runningChallenges: res.data.Permissions[13]?.Status,
              newChallenge: res.data.Permissions[14]?.Status,
              penaltyBonus: res.data.Permissions[15]?.Status,
              bonus: res.data.Permissions[16]?.Status,
              depositHistory: res.data.Permissions[17]?.Status,
              withdrawlHistory: res.data.Permissions[18]?.Status,
              allWithdrawlRequests: res.data.Permissions[19]?.Status,
              allDepositRequests: res.data.Permissions[20]?.Status,
              pages: res.data.Permissions[21]?.Status,
              bonusHistory: res.data.Permissions[22]?.Status,
              bonusReport: res.data.Permissions[23]?.Status,
              withdrawalReport: res.data.Permissions[24]?.Status,
              depositReport: res.data.Permissions[25]?.Status,
              penaltyReport: res.data.Permissions[26]?.Status,
              pinelabDeposit: res.data.Permissions[27]?.Status,
              updateLegalData: res.data.Permissions[29]?.Status,
              GetwaySetting: res.data.Permissions[30]?.Status,
                };
               
              }}
              setState(permission);
                  admindata.user = permission;
                  admindata.user['profile'] = res.data;
         }
            } catch (e) {
              console.log(e)
            }
            finally {
            }
  }

  useEffect(() => {
    onRouteChanged();
    mee()
  }, []);

  useEffect(() => {
    onRouteChanged();
  }, [location]);

  const onRouteChanged = () => {
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = ['/user-pages/login-1', '/user-pages/login-2', '/user-pages/register-1', '/user-pages/register-2', '/user-pages/lockscreen', '/error-pages/error-404', '/error-pages/error-500', '/general-pages/landing-page', '/landing', "/login", "/register", "/adminlogin", "/home", "/profile", "/help", "/Deposit", "/", "/Homepage/pOPULAR", "/KYC/update-pan", "/KYC/update-aadhar", "/Games", "/Referral-history", `/landing/:id`, "/wallet", "/support", "/Withdrawopt", "/Addcase", "/Addfunds", "/Notification", "/refer", "/transaction", "//transaction-history", "/web", "/return", "/redeem/refer", "/transaction-history"];
    
    if (fullPageLayoutRoutes.includes(location.pathname) || location.pathname.split("/")[1] === 'landing' || location.pathname.split("/")[1] === 'viewgame1') {
      setIsFullPageLayout(true);
      document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
    } else {
      setIsFullPageLayout(false);
      document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
    }
  };

  return (
    <div className="container-scroller">
      {!isFullPageLayout && <Sidebar {...state} />}
      <div className="container-fluid page-body-wrapper">
        {!isFullPageLayout && <Navbar usertype={state.usertype} userAname={state.userAname} />}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
          </div>
          {!isFullPageLayout && <Footer />}
        </div>
      </div>
{/* { access_token != null? (
          <>
        
          <ChatCallProvider url={chatConfig.socketUrl} token={token}>
                        <E2eeProvider
                          userId={user?._id}
                          apiUrl={chatConfig.apiUrl}
                          apiKey={chatConfig.apiKey}
                          token={token}
                          enabled={chatConfig.e2ee !== false}
                        >
                          <NotificationSetup chatUser={user} />
                          <ChatWidget
                            room={chatConfig.defaultRoom}
                            username={user?.name || 'Guest'}
                            userId={user?._id}
                            userType={user?.user_type || chatConfig.userType}
                            canViewDev={Boolean(user?.can_view_dev)}
                            showLauncher={showLauncher}
                            hideCallButton={hideCallButton}
                            launcherHorizontal={chatConfig.launcherHorizontal || 'right'}
                            launcherVertical={chatConfig.launcherVertical || 'bottom'}
                            launcherOffsetYPercent={chatConfig.launcherOffsetYPercent ?? 4}
                            launcherOffsetXPercent={chatConfig.launcherOffsetXPercent ?? 3}
                          />
                        </E2eeProvider>
                      </ChatCallProvider>
          </>
        ) : (
          ""
        )} */}
    </div>
   
    
  );
};

export default App;
